import {
  PaymentProfileOptionValue,
  PaymentProfileOption,
} from '../../types/Activity';

const delayedPaymentProfile: PaymentProfileOptionValue = {
  platformProcessingFee: 0, // this is in percent, e.g 3.5% => 3.5
  remittancePeriod: 7, // in days prior to event, i.e. 7. Whole numbers only
  remittanceSchedule: 'daysPrior', //"daysPrior" | "immediate", // The schedule of payment
  feeType: 'percentage',
} as const;

const instantPaymentProfile: PaymentProfileOptionValue = {
  platformProcessingFee: 3.5,
  remittancePeriod: 0,
  remittanceSchedule: 'immediate',
  feeType: 'percentage',
} as const;

export const defaultPaymentProfile: PaymentProfileOptionValue = {
  platformProcessingFee: 0,
  remittancePeriod: 0,
  remittanceSchedule: 'immediate',
  feeType: 'percentage',
} as const;

export const paymentProfileOptions: PaymentProfileOption[] = [
  {
    value: defaultPaymentProfile,
    label: 'Legacy',
  },
  {
    value: delayedPaymentProfile,
    label: 'Delayed',
  },
  {
    value: instantPaymentProfile,
    label: 'Immediate',
  },
];
